var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetflix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke:#000;}.cls-1{stroke-miterlimit:10;}.cls-2{fill:#b1060f;stroke-miterlimit:13.1;stroke-width:3.27px;}.cls-3{fill:url(#radial-gradient);}.cls-4{fill:#e50914;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 17742.76,
    cy: 541.91,
    r: 56.77,
    gradientTransform: "matrix(0.23, -0.08, 2.94, 8.48, -5444.26, -2910.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "netflix-app") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.5,
    width: 511,
    height: 512
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5747"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4155",
    className: "cls-2",
    d: "M289.34,74.3,289.19,159,289,243.68l-7-19.66V224l-9,188.53c8.87,25,13.61,38.36,13.66,38.41s5.09.35,11.19.65c18.45.91,41.34,2.88,58.73,5.05,4,.5,7.46.75,7.71.55s.3-86.4.25-191.61L364.45,74.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4157",
    className: "cls-2",
    d: "M153.49,74.05V265.5c0,105.31.1,191.56.25,191.71s6.66-.5,14.52-1.36,18.7-2,24.1-2.42c8.26-.71,33.06-2.27,35.89-2.32.85,0,.9-4.28,1-81.11l.16-81.11,6,16.94c.91,2.62,1.21,3.43,2.12,6l9-188.48c-1.92-5.39-.91-2.57-3.08-8.72-7.36-20.82-13.61-38.41-13.86-39.22L229.1,74H153.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5715",
    className: "cls-2",
    d: "M289.34,74.3,289.19,159,289,243.68l-7-19.66V224l-9,188.53c8.87,25,13.61,38.36,13.66,38.41s5.09.35,11.19.65c18.45.91,41.34,2.88,58.73,5.05,4,.5,7.46.75,7.71.55s.3-86.4.25-191.61L364.45,74.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5717",
    className: "cls-2",
    d: "M153.49,74.05V265.5c0,105.31.1,191.56.25,191.71s6.66-.5,14.52-1.36,18.7-2,24.1-2.42c8.26-.71,33.06-2.27,35.89-2.32.85,0,.9-4.28,1-81.11l.16-81.11,6,16.94c.91,2.62,1.21,3.43,2.12,6l9-188.48c-1.92-5.39-.91-2.57-3.08-8.72-7.36-20.82-13.61-38.41-13.86-39.22L229.1,74H153.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5719",
    className: "cls-3",
    d: "M153.49,74.05V181.52L229.2,382.35c0-4.58,0-7.1.05-12.35l.16-81.11,6,16.94c33.27,94.37,51.17,145,51.27,145.08s5.09.35,11.19.65c18.45.91,41.34,2.88,58.73,5.05,4,.5,7.46.75,7.71.55s.25-42.39.25-102L289.24,138.47,289.19,159,289,243.68l-7-19.66c-6.8-19.21-11.34-32.06-38.71-109.39C236,93.81,229.76,76.22,229.51,75.41L229,74H153.49v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5721",
    className: "cls-4",
    d: "M153.49,74.05l75.87,215v-.11l6,16.94c33.32,94.32,51.22,144.93,51.32,145s5.09.35,11.19.65c18.45.91,41.34,2.88,58.73,5.05,4,.5,7.46.75,7.66.55L289,243.63v.05l-7-19.66c-6.8-19.21-11.34-32.06-38.71-109.39C236,93.81,229.76,76.22,229.51,75.41L229,74H191.25l-37.76,0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetflix);
export default __webpack_public_path__ + "static/media/netflix.2cf8639c27683953f496419977c666a6.svg";
export { ForwardRef as ReactComponent };